<template>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <transition name="fade">
              <v-card class="elevation-12">
                <v-toolbar
                  color="primary"
                  dark
                  flat
                >
                  <v-toolbar-title>Sales Dashboard Tracking 2 </v-toolbar-title>
                  <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-text-field
                      label="Login"
                      name="login"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="input.username"
                    ></v-text-field>

                    <v-text-field
                      label="Password"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="input.password"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="default" @click="register" >Register</v-btn>
                  <v-btn color="primary" @click="login" >Login</v-btn>
                </v-card-actions>
              </v-card>
            </transition>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
  import { UserService } from '../services/userLogin.service'

  export default {
    name:'Login',
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      input: {
        username:'tata',// dev
        password:'tata'// dev
      }
    }),
    methods: {
        register (){
          this.$router.replace("/Register");
        },
        login (){
          if(this.input.username != "" && this.input.password != "") {

            UserService.login(
              {
                email:this.input.username,  
                password:this.input.password
              }
            ).then( ()=>{
              // Show message
              this.$root.$emit('createAlert',{type:'success',content:'Successful login! '});
              // change route
              this.$router.replace("/Dash");
            });
            
          }
        }
    }
  }
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>